module.exports = __webpack_public_path__ + "img/Coretests.b1f08e27.webp";